export class SnailTrailDriverSearchModel {
  startDateTime: string;
  endDateTime: string;
  reportSearchType: string;
  bookingHashId: string;
  vehicleHashId: string;
  driverHashId: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/snail-trail-driver/models/snail-trail-search.model.ts